// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { isSuppressionRuleResultItem } from "@dashboardApi/apis/engagementAppGroupIdSuppressionRules";

export const isGetEngagementAppGroupIdSuppressionRulesIdResult = objectOf({
  suppression_rule: isSuppressionRuleResultItem,
});
